import { Component, HostListener, inject } from "@angular/core";
import { NgGlyph } from "@ng-icons/core";
import { AppButtonComponent } from "../Button/ButtonComponent";
import { ConfirmModalEffects } from "./State/ConfirmModalEffects";
import { ConfirmModalState } from "./State/ConfirmModalState";

@Component({
  selector: "app-confirm-modal",
  standalone: true,
  imports: [AppButtonComponent, NgGlyph],
  templateUrl: "./ConfirmModalComponent.html",
  styleUrl: "./ConfirmModalComponent.scss",
})
export class ConfirmModalComponent {
  private readonly modalState = inject(ConfirmModalState);
  private readonly modalEffects = inject(ConfirmModalEffects);

  readonly modal = this.modalState.data;

  @HostListener("document:keydown.escape")
  onEscape(): void {
    const current = this.modal();
    if (!current?.isOpen || current.isLoading) {
      return;
    }
    this.modalEffects.cancel();
  }

  onOverlayClick(): void {
    const current = this.modal();
    if (!current?.isOpen || current.isLoading || !current.closeOnOverlay) {
      return;
    }
    this.modalEffects.cancel();
  }

  onCancel(): void {
    this.modalEffects.cancel();
  }

  onConfirm(): void {
    this.modalEffects.confirm();
  }

  getIcon(): string {
    const variant = this.modal()?.variant ?? "primary";
    return (() => {
      if (variant === "danger") {
        return "warning";
      }
      return "info";
    })();
  }
}
